var rofs = {

  /*============= Settings ==============*/
  basket: {},
  log_to_console: true,
  interval_in_seconds: 15,
  preorder_expedited: null,
  delivery_preference: null,

  /**
   * elmahio log level
   * 0 = none
   * 1 = errors only
   * 2 = payment errors
   * 3 = all
   *
   * @param {int}
   */
  elmahio_log: 1,

  /**
   * Main runner of custom JS bits on the site
   * @returns {void}
   */
  start: function () {

    /*============== Wishlist ==============*/

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    
    window.SwymCallbacks.push(function () {
      rofs.wishlist();
    });

    $(document).on('rofsWishlistFilled', function() {
      rofs.update_wishlist_icons();
      rofs.validate_preorder_status();
    });

    /* ========== Image Carousels =========== */
    if ( $('.imagecarousel').length ) {
      $.getScript( $('.imagecarousel').first().data( 'script' ) );
    }

    /*=========== Customisations ===========*/

    /* Ensures if a parent product is removed from cart, any child products are removed too */
    rofs.cart_parent_child_deletion_link();


    /*============= Preorders ==============*/
    /* We need to setup preorder_data, which is required for pre_order add to cart functionality */
    window.preorder_data = window.preorder_data || {};

    /* Looks in the preorders basket and appends a count bubble to the header preorders icon */
    rofs.preorder_dot();

    /*Arm the sitewide add to preorder basket button */
    $('body').on('click', 'button.preorder[type=button]', function (e) {
      e.preventDefault();
      let order_form = $(this).parents('form');
      let variant_id = order_form.find('[name=id]').val();
      let qty = $('.product-form__quantity').find('[name=quantity]').length ? $('.product-form__quantity').find('[name=quantity]').val() : 1;
      let res = rofs.add_to_basket(variant_id, qty);
      if (res) {
        window.location = $(this).data('target');
      }
    });

    $('*[data-js]').each(function () {
      $.getScript($(this).data('js'));
    });

    /* Checks preorder availability status and un-disables the ATC button if it can be ordered */
    rofs.validate_preorder_status();

    /*=========== Bits and Pieces ==========*/

    /* Setup looped conditional for showing/hiding of conditional-display items - i.e. contact phone number */
    rofs.resolve_contact_visibilities();
    window.setInterval(function () {
      rofs.resolve_contact_visibilities();
    }, 1000 * rofs.interval_in_seconds);

    /* Adjust login form redirect? */
    if ($('#customer_login, #create_customer').length) {
      rofs.login_form();
    }

  },

  /*======================================*/
  /*              Preorders               */
  /*======================================*/

  /**
   * Looks in the preorders basket and appends a count bubble to the header preorders icon
   * @returns {void}
   */
  preorder_dot: function () {
    rofs.load_basket();

    let _count = 0;
    if (!$.isEmptyObject(rofs.basket)) {
      $.each(rofs.basket, function (variantid, data) {
        _count += parseInt(data.qty);
      });
    }

    let bubble = $('.header__icon--preorders .preorders-count-bubble');
    if (!_count || _count < 1) {
      bubble.find('span').first().text('');
      bubble.hide();
    } else {
      bubble.find('span').first().text(_count);
      bubble.show();
    }
  },

  /**
   * Sets the basket to include expedited delivery
   * @param {boolean} _state
   * @returns {boolean}
   */
  set_preorder_basket_expedited: function ( _state ) {
    rofs.preorder_expedited = _state ? true : null;
    return rofs.save_basket();
  },

  /**
   * Sets the basket to include expedited delivery
   * @param {boolean|string} _option
   * @returns {boolean}
   */
  set_preorder_delivery_preference: function ( _option ) {
    rofs.delivery_preference = _option ? _option : null;
    return rofs.save_basket();
  },

  /**
   * Gets the current basket expedited state
   * @returns {boolean}
   */
  get_preorder_basket_expedited: function () {
    rofs.log('Getting preorder expedited status');
    rofs.load_basket();
    if ($.isEmptyObject(rofs.basket)) {
      rofs.log('Basket did not load');
      return false;
    }
    rofs.log('rofs.preorder_expedited is ' + rofs.preorder_expedited);
    return rofs.preorder_expedited ? true : false;

  },

  /**
   * Gets the current basket expedited state
   * @returns {string|null}
   */
  get_preorder_delivery_preference: function () {
    rofs.load_basket();
    if ($.isEmptyObject(rofs.basket)) {
      rofs.log('Basket did not load');
      return false;
    }
    return rofs.delivery_preference ? rofs.delivery_preference : null;
  },

  validate_preorder_status: function() {
    $('button[data-validate]:disabled').each(function () {
      var _button = $(this);
      var _url = preorder_api_endpoint.status_single + _button.data('validate')
      $.get(_url, function (data) {
        _button.prop('disabled', data[_button.data('code')] === false);
      });
    });
  },



  /*======================================*/
  /*              Wishlist                */
  /*======================================*/

  /**
   * Runs through products and prompts the conditional styling of wishlist buttons
   * @returns {void}
   */
  update_wishlist_icons: function () {

    if (typeof _swat == 'undefined') {
      window.setTimeout(function () {
        rofs.update_wishlist_icons();
      }, 200);
      return false;

    }

    _swat.fetchWrtEventTypeET(function (products) {
      rofs.update_wishlist_icon(products.length);
      // rofs.log(products)
      for (let i in products) {
        $('.wishlist-button[data-product=' + products[i].empi + ']').addClass('in-wishlist');
      }
    }, _swat.EventTypes.addToWishlist);

  },

  /**
   * Sets styling for header Wishlist Icon Count bubble
   * @returns {void}
   */
  update_wishlist_icon: function (_count) {
    let bubble = $('.header__icon--wishlist .wishlist-count-bubble');
    if (!_count || _count < 1) {
      bubble.find('span').first().text('');
      bubble.hide();
    } else {
      bubble.find('span').first().text(_count);
      bubble.show();
    }
  },

  /**
   * Handles Add To Wishlist and sharing behaviour
   * @returns {void}
   */
  wishlist: function () {

    rofs.update_wishlist_icons();

    $('body').on('click', '.wishlist-button', function (e) {

      e.preventDefault();

      let _button = $(this);
      let _current_count = $('.header__icon--wishlist .wishlist-count-bubble').find('span').first().text();
      if (_current_count) {
        _current_count = parseInt(_current_count);
      } else {
        _current_count = 0;
      }
      let _data = {
        epi: $(this).data('variant'),
        empi: $(this).data('product'),
        iu: $(this).data('image'),
        pr: ($(this).data('price') / 100),
        du: $(this).data('producturl')
      };

      if (_button.is('.in-wishlist')) {
        window._swat.removeFromWishList(_data, function (r) {
          _button.removeClass('in-wishlist')
          rofs.update_wishlist_icon(--_current_count);

          /* If on wishlist page then remove product card */
          let wishlistPageCards = $('#rofs-wishlist');
          if ( wishlistPageCards ) {
            _button.closest('li.product-card-wrapper').remove();
          }
        });


      } else {
        window._swat.addToWishList(_data, function (r) {
          _button.addClass('in-wishlist');
          rofs.update_wishlist_icon(++_current_count);
        });
      }

    });

    let _share_url_facebook = null;
    let _share_url_twitter = null;
    rofs.log(_swat.retailerSettings.Wishlist.SharingModes, true);
    for (let _q in _swat.retailerSettings.Wishlist.SharingModes) {
      if (_swat.retailerSettings.Wishlist.SharingModes[_q].type === 'facebook') {
        _share_url_facebook = _swat.retailerSettings.Wishlist.SharingModes[_q].url;
      }
      if (_swat.retailerSettings.Wishlist.SharingModes[_q].type === 'twitter') {
        _share_url_twitter = _swat.retailerSettings.Wishlist.SharingModes[_q].url;
      }

    }

    // Bind wishlist shares
    $('body').on('click', '.wishlist-shares .icon-facebook', function () {
      let _link = $(this);
      _swat.shareListSocial(
          null,
          _link.parent().data('name'),
          _share_url_facebook,
          "facebook",
          _link.parent().data('note'),
          function (data) {
            rofs.log(data);
            rofs.log_error(data);
            alert('We could&rsquo;t share your list to Facebook right now, please try later.');

          }
      ); // will open facebook share dialog
    });

    $('body').on('click', '.wishlist-shares .icon-twitter', function () {
      let _link = $(this);
      _swat.shareListSocial(
          null,
          _link.parent().data('name'),
          _share_url_twitter,
          "twitter",
          _link.parent().data('note'),
          function (data) {
            rofs.log(data);
            rofs.log_error(data);
            alert('We could&rsquo;t share your list to Twitter right now, please try later.');

          }
      ); // will open twitter share dialog
    });

    $('body').on('click', '.wishlist-shares .icon-email', function () {
      let _link = $(this);

      rofs.modal_open($('#modal_content .share-content').html());


    });


    $('body').on('click', '.wishlist-shares .icon-email', function () {
      let _link = $(this);
      rofs.modal_open($('#modal_content .share-content').html());
    });

    $('body').on('blur keyup', '#modal *[name=share_email]', function () {
      var res = rofs.validate_share_emails();
      if (res.length) {
        $('#modal .button').removeClass('disabled').prop('disabled', false);
      } else {
        $('#modal .button').addClass('disabled').prop('disabled', true);
      }
    });

    $('body').on('click', '#modal *[name=wishlist-email-share] .button', function (e) {
      e.preventDefault();
      rofs.log('Sharing by email');
      let _recipients = rofs.validate_share_emails();
      if (!_recipients.length) {
        return;
      }
      rofs.log('Got addresses');
      let _subject = $.trim($('#modal *[name=share_email_subject]').val());
      if (_subject.length) {
        _subject = $('#modal *[name=share_email_subject]').attr('placeholder');
        rofs.log('Subject = ' + _subject);
      }
      let _content = $.trim($('#modal *[name=share_email_content]').val());
      if (_content.length) {
        _content = $('#modal *[name=share_email_content]').attr('placeholder');
      }
      for (let _i in _recipients) {
        let _email = _recipients[_i];
        _swat.sendListViaEmail(
            {
              toEmailId: _email,
              fromName: _email,
              note: _subject,
              lid: null, // null when multiple list is not enabled
              cprops: {}, // custom props for the share, future usage
            },
            function (r) {
              rofs.log('Submitted');
              $('#modal .main-content').html($('#modal_content .share-submit').html());
            },
            function (r) {
              rofs.log('Email failed!');
            }
        );
      }
    });



  },

  /**
   * Validates the input email text area and returns the
   */
  validate_share_emails: function () {
    let _regex = /\S+@\S+\.\S+/;
    let _input = $('#modal *[name=share_email]').val().split("\n");
    let _emails = [];
    for (let _i in _input) {
      let _test = $.trim(_input[_i]);
      if (!_test) {
        continue;
      }
      if (_regex.test(_test)) {
        _emails.push(_test);
      } else {
        return [];
      }
    }
    return _emails;
  },



  /*======================================*/
  /*        Product Customisations        */
  /*======================================*/

  /**
   * Set of behaviours to keep relations between customisation products and their parents
   * logical when making changes in the basket
   */
  cart_child_quantities_limit: function (line) {
    let formJSON = {
      "updates": {}
    }
    let mainProductID;
    let errors = [];
    let childError = false;

    /* Gets the SKU of the parent product regardless of whether the updated line in the parent or child */
    let parentSKU = $(`#CartDrawer-Item-${line}`).data('parent-sku') ?? $(`#CartDrawer-Item-${line}`).data('sku');

    $(`.cart-item[data-sku="${parentSKU}"]`).each( function() {
      mainProductID = $(this).find('.quantity__input').attr('data-quantity-variant-id');
      mainProductName = $(this).find('.cart-item__name').text();

      /* Get parent product SKU and quantity */
      let _sku = $(this).data('sku');
      let _qty = $(this).find('.quantity__input').val();
      let _inventory_quantity =  parseInt( $(this).find('.quantity__input').data('inventory-quantity') );

      /* Checks requested product quantity does not exceed stock level, if it does then adjust to max possible and add a line error */
      if ( parseInt( _qty ) > parseInt( _inventory_quantity ) ) {
        _qty = _inventory_quantity;
        $(this).find('.quantity__input').attr('max', _inventory_quantity);

        errors.push({
          'line': $(this).find('.quantity__input').data('index'),
          'message': `Maximum quantity reached: All ${_qty} ${mainProductName} in stock are already in your cart.`
        })
      }

      /* Set all parent quantity input values/attributes */
      $(this).find('.quantity__input').val(_qty);
      $(this).find('.quantity__input').attr('value', _qty);
      $(this).find('.quantity__input').attr('data-cart-quantity', _qty);

      /* Set update JSON update line for main product */
      let _input = $(this).find('.quantity__input');
      formJSON["updates"][String(_input.closest('.cart-item').attr('data-line-key'))] = _input.val();

      /* If there are child products then check and possibly limit them based on parent quantity */
      $(`.cart-item[data-parent-sku="${_sku}"] .quantity__input`).each( function(i) {
        let _input_field = $(this);
        let _current_qty = _input_field.val();

        /* Set new max if parent max is what has changed */
        _input_field.attr('max', _qty);

        /* If number of addons will exceed number of parent products then prevent this */
        if ( parseInt(_current_qty ) > parseInt( _qty ) ) {

          /* Drop quantity of child product back down to acceptable level */
          _input_field.val(_qty);
          _input_field.attr('value', _qty);
          _input_field.attr('data-cart-quantity', _qty);

          /* Add error to be dispalyed in cart */
          errors.push({
            'line': _input_field.data('index'),
            'message': "Quantity of product customisations cannot exceed that of the product it's being applied to: This has been automatically corrected."
          })

          /* If a child line has an error then add the parent line to make sure it's loading status can be removed correctly */
          if ( childError === false ) {
            childError = true; // We only need to add this once per parent
            errors.push({
              'line': _input.data('index'),
              'message': false
            })
          }
        }
        /* If the quantity is acceptable then set all quantity input values/attributes */
        else {
          _input_field.val(_current_qty);
          _input_field.attr('value', _current_qty);
          _input_field.attr('data-cart-quantity', _current_qty);
        }

        /* Set update JSON update line for this child product */
        formJSON["updates"][String(_input_field.closest('.cart-item').attr('data-line-key'))] = _input_field.val();
      });

    });

    /* Adding cart drawer bits, if using cart drawer and there aren't any custom errors to show */
    let cart = $('document cart-notification') || $('document cart-drawer');
    if ( cart && errors.length===0 ) {
      let drawer =  document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      formJSON['sections'] =  drawer.getSectionsToRender().map((section) => section.id);
      formJSON['sections_url'] = window.location.pathname;
    }

    /* Return all the needed data in an array */
    return[ formJSON, mainProductID, errors ];
  },


  /**
   * Ensures if a parent product is entirely removed from the cart then the child customisations are too
   */
  cart_parent_child_deletion_link: function () {

    /* Ensure when a main product is deleted from cart, any of it's additions are too */
    $('body').on('click', '.cart-remove-button', function (e) {

      /* Stops form submitting normally, as we are doing the Deletions via JS */
      e.preventDefault();

      /* Will be the body of the Updates API request */
      let formJSON = {
        "updates": {}
      }

      let _parent_row = $(this).parents('.cart-item');
      let _sku = _parent_row.data('sku');

      /* Adding Main Product to updates object */
      let mainProductID = _parent_row.find('.quantity__input').attr('data-quantity-variant-id');
      formJSON["updates"][mainProductID] = 0;

      /* Adding Customisation Addons to updates object if there are any linked to the main product */
      if ( _sku ) {
        $(`.cart-item[data-parent-sku="${_sku}"]`).each( (i, item) => {
          let addonID = $(item).find('.quantity__input').attr('data-quantity-variant-id');
          formJSON["updates"][addonID] = 0;
        })
      }

      /* Adding cart drawer bits */
      let cart = $('document cart-notification') || $('document cart-drawer');
      if ( cart) {
        let drawer =  document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        formJSON['sections'] =  drawer.getSectionsToRender().map((section) => section.id);
        formJSON['sections_url'] = window.location.pathname;
        drawer.setActiveElement(document.activeElement);
      }

      /* API request - Update cart */
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify( formJSON )
      })
          .then(response => {
            return response.json();
          })
          .then( response => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainProductID,
              cartData: response,
            });

            let drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if ( drawer )  {
              drawer.renderContents(response);
              if ( response.items.length === 0 ) {
                drawer.classList.add('is-empty');
              }
            }

          })
          .catch((error) => {
            console.error('Error:', error);
          });

      return false;
    });
  },



  /*======================================*/
  /*             Preorders                */
  /*======================================*/

  /**
   * If we have a login form, look for a return_to get variable and add it to the target
   * @returns {void}
   */
  login_form: function () {

    let redirect_url = rofs.get_get_var("return_to");
    if (redirect_url) {
      $('#customer_login')?.find('input[type=hidden]').last().after('<input type="hidden" name="checkout_url" value="' + redirect_url + '">');
      $('#create_customer')?.find('input[type=hidden]').last().after('<input type="hidden" name="return_to" value="' + redirect_url + '">');
    }

  },

  /**
   * Stops preorder provinces defaulting to British Forces?
   * @returns {void}
   */
  filter_provinces: function () {
    /* Remove British Forces option on first page load*/
    $('#address_province_delivery option[value="British Forces"], #address_province_billing option[value="British Forces"]').each(function() {
      $(this).remove();
    });

    /* Set up mutation observer to make sure the British Forces option is always hidden even when it is re added dynamically when country changes etc */
    let _config = { childList: true };
    $('#address_province_delivery, #address_province_billing').each(function () {
      let _target_node = this;
      let _callback = function (mutationsList, observer) {
        mutationsList.forEach( mutation => {
          if (mutation.type === 'childList') {
            $('#address_province_delivery option[value="British Forces"], #address_province_billing option[value="British Forces"]').each(function() {
              $(this).remove();
            });
          }
        })
      };
      // Create an observer instance linked to the callback function
      let observer = new MutationObserver(_callback);
      observer.observe(_target_node, _config);
    });
  },

  /**
   * Load the basket from the cookie
   * @returns {bool}
   */
  load_basket: function () {
    let rofs_basket = window.localStorage.getItem('rofsbasket');

    if (!rofs_basket) {
      rofs.basket = {};
    }
    let payload = JSON.parse(rofs_basket);
    if (payload) {
      rofs.basket = payload.basket;
    }
    if ($.isEmptyObject(rofs.basket)) {
      rofs.basket = {};
      return false;
    }

    if (payload.expedited) {
      rofs.log('loading expedited status');
      rofs.preorder_expedited = true;
    }

    // rofs.log('loading delivery_preference status ' + payload.delivery_preference );
    if (payload.delivery_preference) {
      rofs.log('loading delivery_preference status ' + payload.delivery_preference);
      rofs.delivery_preference = payload.delivery_preference;
    }

    return true;
  },
  /**
   * Set the specific value of a single basket row
   * @param variant_id
   * @param qty
   * @param available
   * @return {boolean}
   */
  update_basket: function( variant_id, qty, available ) {

    rofs.load_basket();

    /**
     * If we cannot find a row in the basket to update then do nothing
     */
    if ( typeof rofs.basket[variant_id] === 'undefined' ) {
      return false;
    }

    qty = parseInt(qty);
    if ( available ) {
      available = parseInt( available );
      if ( Number.isInteger( available ) && qty < available ) {
        qty = available;
      }
    }

    /**
     * If none available or no quantity requested, remove from rofs basket
     * save it and return
     */
    if ( qty === 0 ) {
      delete rofs.basket[ variant_id ];
    } else {
      rofs.basket[variant_id].qty = qty;
    }

    rofs.save_basket();
    return true;

  },
  /**
   * Add the requested element into the preorder basket
   * @param {string} variant_id
   * @param {int|string} qty - converted to integer before processing
   * @returns {bool}
   */
  add_to_basket: function (variant_id, qty) {

    // It is possible the basket has been altered elsewehere (on another tab)
    // re-import the basket before making additions
    rofs.load_basket();

    qty = parseInt(qty);
    if ( ! qty || isNaN( qty ) ) {
      // in theory ! qty is sufficient but isNaN should be bomb-proof
      qty = 1;
    }

    if (rofs.basket[variant_id]) {
      rofs.basket[variant_id].qty = (typeof rofs.basket[variant_id].qty !== 'undefined' ? parseInt(rofs.basket[variant_id].qty) : 0) + qty;
    } else if (typeof preorder_data !== 'undefined') {
      if (!preorder_data[variant_id]) {
        alert('No preorder data could be found for this item, sorry');
        return false;
      }
      rofs.basket[variant_id] = preorder_data[variant_id];
      rofs.basket[variant_id].qty = qty;
    }
    rofs.save_basket();
    return true;
  },

  /**
   * Save the basket data into localStorage
   * @returns {void}
   */
  save_basket: function () {
    if (!rofs.basket.length) {
      window.localStorage.removeItem('rofsbasket');
    }
    let a = new Date();
    let basket = {
      expedited: rofs.preorder_expedited ? true : null,
      delivery_preference: rofs.delivery_preference ? rofs.delivery_preference : 'same',
      d: a.getTime().toString(),
      basket: rofs.basket
    };
    let rofs_basket = JSON.stringify(basket);
    window.localStorage.setItem('rofsbasket', rofs_basket);
  },

  /**
   * Clears the entire Preorder basket data from localStorance
   * @returns {void}
   */
  clear_basket: function () {
    window.localStorage.removeItem('rofsbasket');
  },

  /**
   * Converts the entire basket object into a string for passing into the Azure app
   * @returns {Array|rofs.build_basket_payload._payload}
   */
  build_basket_payload: function () {

    let _payload = [];

    $.each(rofs.basket, function (variant_id, data) {
      _payload.push({
        ItemId: variant_id,
        ProductCode: data.code,
        BasketQuantity: parseInt(data.qty),
        ProductTitle: data.title
      });
    });

    rofs.log(JSON.stringify(_payload, null, 4));

    return _payload;

  },



  /*======================================*/
  /*                Modals                */
  /*======================================*/

  /**
   * Create a modal overlay and populate it (if required)
   * @param {string|null} markup
   * @returns {void}
   */
  modal_open: function (markup, soft) {

    if ($('#modal').length) {
      rofs.modal_close(true, function () {
        rofs.require_modal(markup, soft);
      });
    } else {
      rofs.require_modal(markup, soft);
    }
  },

  /**
   * Close the modal plus the overlay if requested
   * @param {boolean|null} preserve_overlay If closing and opening another, preserve the overlay
   * @param {function|null} callback_fn
   * @returns {void}
   */
  modal_close: function (preserve_overlay, callback_fn) {
    let _target_group = preserve_overlay ? $('#modal') : $('#modal, #modal_overlay');
    if (!_target_group.length) {
      if (typeof callback_fn === 'function') {
        callback_fn();
      }
      return;
    }
    _target_group.animate({
      opacity: 0
    }, function () {
      $( 'body' ).trigger( 'modal_close' );
      _target_group.remove();
      if (typeof callback_fn === 'function') {
        callback_fn();
      }
    });
  },

  /**
   * Add the modal to the page
   * @param {string|null} markup - content to add to the window
   * @param {bool|null} soft - if true, clicking the page background will dispel the modal
   * @returns {void}
   */
  require_modal: function (markup, soft) {
    rofs.require_modal_overlay();
    if (!$('#modal').length) {
      $('body').prepend('<div id="modal" class="hidden box-shadow"><span class="icon icon-cancel absolute"></span>'
          + '<div><div class="padded_div main-content">' + (markup ? markup : '') + '</div></div></div>');
      $('#modal > .icon-cancel').on('click', function () {
        rofs.modal_close();
      });
      $('#modal').removeClass('hidden');
      if (!soft) {
        $('#modal').addClass('modal');
      }
    }
  },

  /**
   * Ensures there is an overlay div
   * @returns {void}
   */
  require_modal_overlay: function () {
    if (!$('#modal_overlay').length) {
      $('body').prepend('<div id="modal_overlay" class="hidden"></div>');
      $('#modal_overlay').removeClass('hidden').unbind('click').on('click', function () {
        modal_close();
      });
    }
  },




  /*======================================*/
  /*            Bits and Pieces           */
  /*======================================*/

  /**
   * Extracts a $_GET variable from the URL and returns its value
   * @param {string} variable
   * @returns {rofs.get_get_var.pair|Boolean}
   */
  get_get_var: function (variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return (false);
  },

  /**
   * Hide phone numbers and the like when out of office hours
   * @returns {void}
   */
  resolve_contact_visibilities: function () {
    $('.conditional-display').each(function () {
      var _show = true;
      var _this = $(this);
      var _d = new Date();
      _d.toLocaleString('en-GB', { timeZone: 'Europe/London' });
      var _hour_now = _d.getHours();
      var _minute_now = _d.getMinutes();
      var _day_now = _d.getDay();

      // rofs.log('h: ' + _hour_now + ' m: ' + _minute_now + ' d: ' + _day_now);
      if (_this.data('after')) {
        let _spec = _this.data('after');
        // rofs.log('Looking for times after ' + _spec);
        let _conditions = _spec.toString().split('.');
        if (_conditions[0] && _conditions[0] > _hour_now) {
          _show = false;
        } else if (_conditions[1] && _conditions[1] > _minute_now && _conditions[0] == _hour_now) {
          _show = false;
        }
      }

      if (_this.data('before')) {
        let _spec = _this.data('before');
        // rofs.log('Looking for times before ' + _spec);
        let _conditions = _spec.toString().split('.');
        if (_conditions[0] && _hour_now >= _conditions[0]) {
          if (_conditions[1]) {
            if (_minute_now > _conditions[1]) {
              _show = false;
            }
          } else {
            _show = false;
          }
        }
      }

      if (_this.data('dow')) {
        let _conditions = _this.data('dow').split(',');
        if (_conditions.indexOf(_day_now.toString()) === -1) {
          _show = false;
        }
      }

      if (!_show) {
        _this.addClass('hidden');
      } else {
        _this.removeClass('hidden');
      }
    });
  },

  /**
   * Formats integer money values as rails preferences
   * @param {int} int
   * @param {string} format - the format in which values should be displayed
   * @param {type} currency the currency code
   * @returns {String|Number}
   */
  format_money: function (int, format, currency) {
    if (!currency) {
      currency = '£';
    }
    let centiles = int % 100;
    let units = Math.floor(int / 100);
    let return_val = currency + units;
    if (!centiles) {
      return return_val; // comment out if you want do display centile values against integer prices e.g. '$41.00' not '$41'
    }
    centiles = Math.round(centiles);
    centiles = String(centiles).padStart(2, '0');
    switch (format) {
      case ('period'):
        return_val += '.' + centiles;
        break;
      case ('comma'):
        return_val += ',' + centiles;
        break;
      default:
        return_val += '<span class="superscript">' + centiles + '</span>';
        break;
    }
    return return_val;
  },


  maybeAppendInfiniteLoad: function () {
    /* Function that runs after infinite page load, if on last page of results then hide loading message */
    const infiniteLoadCallback = ( responseXML ) => {

      rofs.validate_preorder_status();

      if ( ! responseXML.querySelector('.infinite_next a') ) {
        $('.pagination__loading-message').hide();
      } else {
        $('.pagination__loading-message').show();
      }
    }

    /* If window is narrow enough (i.e. for phones/tablets) initialize infinite scrolling */
    if ( window.innerWidth < 990 ) {
      endlessScroll = new Ajaxinate({
        container: '.product-grid',
        pagination: '.infinite_next',
        callback: infiniteLoadCallback
      });
    }
  },


  /*======================================*/
  /*          Development Helpers         */
  /*======================================*/

  /**
   * Logs to the console if specified to do so
   * @param {string} data
   * @param {bool} json
   * @returns {boolean}
   */
  log: function (data, json) {
    if (rofs.log_to_console === false) {
      return false;
    }
    if (!json) {
      console.log(data);
      return true;
    }
    console.log(JSON.stringify(data, null, 4));
    return true;
  },

  /**
   * Write an event to the external logging service
   * @param {type} message
   * @param {type} err
   * @returns {undefined}
   */
  log_error: function (message, err) {

    let _host = window.location.host;

    if (_host !== 'railsofsheffield.com') {
      return;
    }

    let _api_key = '2ad85ee047eb41d79e473964ece526f1';
    let _log_id = '0cec8423-fdbc-4817-afa5-b08dea110129';
    let _logger = new Elmahio({
      apiKey: _api_key,
      logId: _log_id,
      debug: rofs.log_to_console,
      application: _host // log the current domain
    });

  }

}

/* Run main function on document ready */
$(rofs.start);


